import React from 'react';

export interface StarProps {
  isEmpty: boolean;
  height?: number;
  width?: number;
}

export const Star = ({ isEmpty, height = 14, width = 14 }: StarProps) => (
  <svg height={height} width={width} viewBox="0 -5 31 41" className="star">
    <path
      fill="#FBD033"
      fillOpacity={isEmpty ? '0' : '1'}
      strokeWidth={2}
      stroke="#FBD033"
      d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118 l11.547-1.2L16.026,0.6L20.388,10.918z"
    ></path>
  </svg>
);
